import useFeatureFlags from 'hooks/useFeatureFlags';

export const useOnboardingHighlights = () => {
  const {
    flags: { useComposeTeamHighlights = false },
  } = useFeatureFlags();

  return useComposeTeamHighlights;
};
